import React, { Fragment } from "react";
import { BrowserRouter, Route, Routes, Switch } from 'react-router-dom';
import Index from "./components";
import Section from "./components/Section";
import Detail from "./components/DetailEvent";
import FormOrder from "./components/FormOrder";
import Ticket from "./components/Ticket";
import "./theme.scss";
import "./assets/css/themify-icons.css";
import "./assets/css/style.css";
import AppLayout from "./components";

export default function App() {
    return (
      <>
        <Routes>
          <Route element={<AppLayout />}>
            <Route path="/" element={<Section />} />
            <Route path="/detail/:code" element={<Detail />} />
            <Route path="/form-order" element={<FormOrder />} />
            <Route path="/ticket/:code_reg" element={<Ticket />} />
          </Route>
        </Routes>      
      </>
    );
}
